export default __webpack_public_path__ + "static/app-features-6-1a3078c9c134168ebae2da9bcf47b839.png";